"use client";
import { jsxs as r, jsx as t } from "react/jsx-runtime";
import e from "clsx";
import x from "next/image";
import u from "next/link";
import { Box as g } from "../base/Base.js";
import { s } from "../../Offer.module-BtxYVTfL.js";
const L = ({
  image: f,
  href: a,
  onClick: i,
  onClose: o,
  title: p,
  text: N,
  theme: c = "friday",
  children: l,
  ...m
}) => {
  const n = e(s.offer, s[c], {
    [s._children]: l,
    [s._pointer]: i || a
  }), d = /* @__PURE__ */ r(g, { gap: 12, row: !0, align_center: !0, wide: !0, children: [
    /* @__PURE__ */ t(
      x,
      {
        className: e(s.image, s[c]),
        src: f,
        alt: "Sale",
        width: 1512,
        height: 56,
        priority: !0,
        quality: 100
      }
    ),
    /* @__PURE__ */ r("div", { className: e(s.content), children: [
      /* @__PURE__ */ t("span", { className: s.title, children: p }),
      /* @__PURE__ */ t("span", { className: e(s.text, s.text__bold), children: N })
    ] }),
    o && /* @__PURE__ */ t(
      "div",
      {
        className: e("material-icons", s.close),
        "data-icon": "close",
        onClick: o
      }
    )
  ] });
  return a ? /* @__PURE__ */ r(
    u,
    {
      href: a,
      scroll: !1,
      className: n,
      onClick: i,
      ...m,
      children: [
        d,
        l
      ]
    }
  ) : /* @__PURE__ */ r("div", { className: n, onClick: i, ...m, children: [
    d,
    l
  ] });
};
export {
  L as OfferNoTimer
};
